module.exports = __webpack_public_path__ + "img/map-marker.26c2c94.svg";